const commonErrorTransPath = 'error.pageNotFound.';
const errorButtonsTransPath = commonErrorTransPath + 'buttons.';


 const errorTranslations = {
    STATUS_CODE: commonErrorTransPath + "status",
    PAGE_NOT_FOUND_TITLE: commonErrorTransPath + "pageError",
    PAGE_NOT_FOUND_DESCRIPTION: commonErrorTransPath + "pageNotFoundMsg",

    GOT_TO_HOME: errorButtonsTransPath + "goToHome",
    GOT_TO_LOGIN: errorButtonsTransPath + "gotToLogin",
}

export default errorTranslations